module.exports = __webpack_public_path__ + "img/78.3042b9c2.jpg";